<template>
  <div class="bitacora">
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            <CRow style="width: 100%">
              <span style="display: inline-block; padding: 0 15px">
                Bitácora Cuadre fiscal
              </span>
              <CCol
                class="justify-content-end align-items-center flex-wrap d-flex p-0"
                style="gap: 5px"
              >
                <BackButton
                  :to="{ name: backInfo, params: { config: config } }"
                >
                  <CButton color="primary" class="mr-1 btn-header">
                    <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                  </CButton>
                </BackButton>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow class="mt-3 mb-4">
              <CCol md="6">
                <label class="d-block">Periodo:</label>
                <DateSelector
                  class="z-custom-2 mb-2"
                  :date="filter.fecha"
                  @input="setPeriodo"
                />
              </CCol>
              <CCol col="6" class="pt-3">
                <label class="d-block">Trabajador:</label>
                <div class="d-flex margin-multi align-items-center">
                  <MultiSelectC
                    v-model="filter.trabajadores"
                    :options="trabajadores"
                    :multiple="true"
                    :loading="!showtable"
                    label="label"
                    track-by="label"
                    placeholder="Trabajadores"
                    :close-on-select="false"
                    :clear-on-select="false"
                  >
                    <template #no-options>Sin resultados.</template>
                  </MultiSelectC>
                  <transition name="fade">
                    <div
                      v-show="filter.trabajadores && filter.trabajadores.length"
                      @click="
                        () => {
                          filter.trabajadores = [];
                        }
                      "
                    >
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
              <CCol col="6" class="pt-3">
                <label class="d-block">Empresa:</label>
                <div class="d-flex margin-multi align-items-center">
                  <MultiSelectC
                    v-model="filter.empresas"
                    :options="empresas"
                    :multiple="true"
                    :loading="!showtable"
                    label="label"
                    track-by="label"
                    placeholder="Empresas"
                    :close-on-select="false"
                    :clear-on-select="false"
                  >
                    <template #no-options>Sin resultados.</template>
                  </MultiSelectC>
                  <transition name="fade">
                    <div
                      v-show="filter.empresas && filter.empresas.length"
                      @click="
                        () => {
                          filter.empresas = [];
                        }
                      "
                    >
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
              <CCol col="6" class="pt-3">
                <label class="d-block">Ubicacion raiz:</label>
                <div class="d-flex margin-multi align-items-center">
                  <MultiSelectC
                    v-model="filter.ubicaciones_raiz"
                    :options="ubicaciones"
                    :multiple="true"
                    :loading="!showtable"
                    label="label"
                    track-by="label"
                    placeholder="Ubicaciones raiz"
                    :close-on-select="false"
                    :clear-on-select="false"
                  >
                    <template #no-options>Sin resultados.</template>
                  </MultiSelectC>
                  <transition name="fade">
                    <div
                      v-show="
                        filter.ubicaciones_raiz &&
                        filter.ubicaciones_raiz.length
                      "
                      @click="
                        () => {
                          filter.ubicaciones_raiz = [];
                        }
                      "
                    >
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
              <CCol col="6" class="pt-3">
                <CButton @click="actualizarInfo" color="primary">
                  Buscar</CButton
                >
              </CCol>
            </CRow>
            <CRow>
              <CCol
                class="indicator mb-4"
                v-for="indicator of indicators"
                :key="indicator.key"
              >
                <div class="info">
                  <h2>{{ indicator.key }}</h2>
                  <h3>{{ indicator.value }}</h3>
                </div>
              </CCol>
            </CRow>
            <datatable
              :columns="columns"
              :data="xdata"
              :total="total"
              :query="query"
              :tbl-style="tblStyle"
              :HeaderSettings="false"
              :Pagination="true"
              :fixHeaderAndSetBodyMaxHeight="500"
            >
              <template #ubicacion_principal_id="{ rowData }">
                <div style="text-align: center">
                  {{ rowData.ubicacion_principal }}
                </div>
              </template>
              <template #trabajador_id="{ rowData }">
                <div style="text-align: center">{{ rowData.trabajador }}</div>
              </template>
              <template #empresa_id="{ rowData }">
                <div style="text-align: center">{{ rowData.empresa }}</div>
              </template>
              <template #fecha_inicial="{ rowData }">
                <div style="text-align: center">
                  {{ toMoment(rowData.fecha_inicial) }}
                </div>
              </template>
              <template #fecha_final="{ rowData }">
                <div style="text-align: center">
                  {{ toMoment(rowData.fecha_final) }}
                </div>
              </template>
              <template #documentos_relacionados="{ rowData }">
                <div style="text-align: center">
                  {{ rowData.documentos_relacionados }}
                </div>
              </template>
            </datatable>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <CButton @click="launch()" class="px-4 mx-3 btn-lg" color="success">
              <span>Generación de documentos</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      size="sm"
      title="Reporte"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >
      {{ error }}
    </CModal>
  </div>
</template>

<script>
import Datatable from "vue2-datatable-component";
import moment from "moment";
import DateSelector from "../../../customComponents/DateSelector";
import GridAutorMixin from "../../../mixins/GridAutor";

import FilterTh from "../Depuraciones/utils/th-Filter";
import EmptyTh from "../Depuraciones/utils/th-Empty";
import mockData from "../Depuraciones/utils/filter";

import { validationMixin } from "vuelidate";
import "vue-select/dist/vue-select.css";

/*
  {
    "fecha_inicial":"2023-03-09",
    "fecha_final":"2023-03-15",
    "empresa_id":1,
    "trabajador_id":1,
    "ubicacion_principal_id":1209,
    "documentos_relacionados":4
  }
  */

export default {
  name: "BitacoraNomina",
  components: {
    DateSelector,
    Datatable,

    FilterTh,
    EmptyTh,
  },
  mixins: [GridAutorMixin, validationMixin],
  data() {
    return {
      backInfo: this.$route.params.backInfo || "Labor",

      iter: null,
      showtable: false,
      trabajadores: [],
      empresas: [],
      ubicaciones: [],
      filter: {
        fecha: {
          start: moment().startOf("month").toDate(),

          end: moment().endOf("month").toDate(),
        },
      },
      query: {
        limit: 10,
      },
      tblStyle: {
        "table-layout": "fixed",
      },
      columns: [
        {
          field: "fecha_inicial",
          title: "Fecha Inicial",
          sortable: true,
          filterable: true,
          thComp: "FilterTh",
          colStyle: {
            width: "125px",
          },
        },
        {
          field: "fecha_final",
          title: "Fecha Final",
          sortable: true,
          filterable: true,
          thComp: "FilterTh",
          colStyle: {
            width: "125px",
          },
        },
        {
          field: "trabajador_id",
          title: "Trabajador",
          sortable: true,
          filterable: true,
          lists: "trabajadores",
          thComp: "FilterTh",
          colStyle: {
            width: "185px",
          },
        },
        {
          field: "ubicacion_principal_id",
          title: "Ubicacion raiz",
          sortable: true,
          filterable: true,
          thComp: "FilterTh",
          colStyle: {
            width: "145px",
          },
        },
        {
          field: "empresa_id",
          title: "Empresa",
          sortable: true,
          filterable: true,
          thComp: "FilterTh",
          colStyle: {
            width: "100px",
          },
        },
        {
          field: "documentos_relacionados",
          title: "# Documentos",
          sortable: true,
          filterable: true,
          thComp: "FilterTh",
          colStyle: {
            width: "145px",
          },
        },
        {
          field: "status",
          title: "Estatus",
          sortable: true,
          filterable: true,
          thComp: "FilterTh",
          colStyle: {
            width: "100px",
          },
        },
        // {
        //   title: "Actions",
        //   field: "actions",
        //   fixed: "left",
        //   thComp: "EmptyTh",
        //   colStyle: {
        //     width: "0px",

        //   },
        //   tdStyle: {
        //     padding: 0
        //   },
        //   thStyle: {
        //     padding: 0
        //   }
        // }
      ],
      items: [],
      allItems: [],

      limit: 10,
      total: 0,
      laboresCheck: {},
      loadingModal: "",
      show: false,
      showInfo: false,

      showHora: false,
      showCratedAt: false,
      advanceFilter: false,

      agrupar: false,
      collapseItem: {},

      warningModal: false,
      error: "",
      labores: [],
      config: this.$route.params.config,
      dropdownCustom: false,
      showCancel: false,
      isLoteActive: true,
      isCreated: false,
      color1: "primary",
      color2: "secondary",
      noItems: {
        noResults: "Sin Resultados",
        noItems: "Sin Resultados",
      },

      ubicaciones_principales: [],
      ubicacion_principal: 0,
      actualSort: "doc_labores.payload->encabezado->fechahora",
      actualSortJoin: "",
      cambioUbicacionRaiz: false,
      // ubicacionesAll: [],
      // cultivos: [],
      // cultivosAll: [],
      // lotes: [],
      showPagosDias: false,

      actividades: [],
      actividadesAll: [],
      empresa: "",
      trabajador: "",

      pagosDias: [],
      showTablePagosDias: false,
      showPrintLabel: false,

      // cultivo: null,
      // ubicacion: null,
      // lote: null,
      fechaCalcularPD: false,
      fechaCalcularPagoDias: {
        start: moment().startOf("month").toDate(),

        end: moment().endOf("month").toDate(),
      },

      showUbicaciones: false,
      itemModal: {
        id: "",
        name: "",
        index: "",
      },

      cancelModal: false,
      isLoading: false,
      isLoadingInfo: false,
      alertError: false,
      message: "",
      page: 1,
      pages: 1,
      sorting: "desc",
      sortingJoin: "",
      loader: {},
      printLabelLoader: false,
    };
  },

  created() {
    this.actualizarCatalogos();
  },
  destroyed() {
    clearTimeout(this.iter);
  },

  computed: {
    indicators() {
      return this.allItems.reduce(
        (v, c) => {
          const itm = v.find((f) => f.key === c.status);
          if (itm) {
            itm.value++;
          }
          return v;
        },
        [
          {
            key: "En espera",
            value: 0,
          },
          {
            key: "En proceso",
            value: 0,
          },
          {
            key: "Error",
            value: 0,
          },
        ]
      );
    },
    xdata() {
      /*
        {
          "fecha_inicial":"2023-03-09",
          "fecha_final":"2023-03-15",
          "empresa_id":1,
          "trabajador_id":1,
          "ubicacion_principal_id":1209,
          "documentos_relacionados":4
        }
        */
      return this.items.map((m) => ({
        ...m,
        trabajador: this.trabajadores.find((f) => f.id === m.trabajador_id)
          ?.label,
        empresa: this.empresas.find((f) => f.id === m.empresa_id)?.label,
        ubicacion_principal: this.ubicaciones.find(
          (f) => f.id === m.ubicacion_principal_id
        )?.label,
      }));
    },
    query_filter() {
      const body = {
        params: {},
        ubicacion_raiz_id: this.ubicacionRaiz,
      };
      body.params = Object.keys(this.filter).reduce((v, key) => {
        const item = this.filter[key];
        switch (key) {
          case "fecha": {
            v[key] = [
              moment(item.start).format("YYYY-MM-DD HH:mm:ss"),
              moment(item.end).format("YYYY-MM-DD HH:mm:ss"),
            ];
            break;
          }
          default: {
            v[key] = item
              .map((m) => m.id)
              .sort((a, b) => Number(a) - Number(b));
            break;
          }
        }
        return v;
      }, {});
      return body;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
  },

  watch: {
    query: {
      handler() {
        this.actualizarInfo();
      },
      deep: true,
    },
    limit() {
      this.actualizarInfo();
    },
    ubicacionRaiz: function () {
      this.page = 1;
      if (this.ubicacionRaiz == "") {
        this.items = [];
        return;
      }
      this.cambioUbicacionRaiz = true;
      this.actualizarInfo();
      this.actualizarCatalogos();
    },
  },

  methods: {
    toMoment(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
    },
    setPeriodo(v) {
      this.filter.fecha = v;
    },
    actualizarCatalogos() {
      const promises = [
        //
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          "with-trashed": true,
          filter: {
            where: [
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaiz}[[:>:]]`,
              },
              {
                field: "payload->suspendido",
                operator: "=",
                value: false
              },
            ],
          },
        }),
        //
        this.$store.dispatch("customHTTP", {
          schema: "empresas",
        }),
        //
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->pertenece_id",
                value: 0,
                operator: "=",
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "=",
              },
            ],
          },
          order: [{ field: "payload->nombre", direction: "asc" }],
        }),
      ];

      Promise.all(promises)
        .then(([trabajadores, empresas, ubicaciones]) => {
          this.trabajadores = trabajadores.data
            .map((trabajador) => {
              return {
                id: trabajador.id,
                label: trabajador.payload.nombre,
                unidad: trabajador.payload.unidad,
                unidad_extra: trabajador.payload.unidad_extra,
                deleted: trabajador.deleted_at !== null,
              };
            })
            .sort((a, b) => a.label.localeCompare(b.label));

          this.empresas = empresas.data
            .map((actividad) => {
              return {
                id: actividad.id,
                nombre: actividad.payload.nombre,
                label: actividad.payload.nombre,
              };
            })
            .sort((a, b) => a.label.localeCompare(b.label));

          this.ubicaciones = ubicaciones.data
            .map((ubicacion) => {
              return {
                id: ubicacion.id,
                nombre: ubicacion.payload.nombre,
                label: ubicacion.payload.nombre,
                pertenece_id: ubicacion.payload.pertenece_id,
                cultivo_id: ubicacion.payload.cultivo_id,
                ruta: ubicacion.payload.ruta,
              };
            })
            .sort((a, b) => a.nombre.localeCompare(b.nombre));
        })
        .finally(() => {
          this.showtable = true;
        });
    },
    actualizarInfo() {
      clearTimeout(this.iter);
      if (!this.ubicacionRaiz) {
        return;
      }
      this.$store
        .dispatch("httpAny", {
          endpoint: "ajuste_fiscal:consultar_documentos",
          body: this.query_filter,
        })
        .then((response) => {
          this.allItems = response.data;
          mockData(this.query, response.data, this.columns, this.$data)
            .then(({ rows, total, filterApply }) => {
              this.filterApply = filterApply;
              this.items = rows;
              this.total = total;
            })
            .finally(() => {
              this.iter = setTimeout(() => {
                this.actualizarInfo();
              }, 30000);
            });
          // this.items = ;
          // this.total = response.data.length;
        });
    },
    launch() {
      this.$store
        .dispatch("httpAny", {
          endpoint: "ajuste_fiscal:procesar_ajuste_fiscal",
        })
        .then(() => {
          this.actualizarInfo();
        });
    },
  },
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.footer-table {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.dropdown-menu {
  min-width: 14rem;
}
.advance-filter .multiselect__spinner {
  height: 30px;
}
.advance-filter .multiselect__placeholder {
  margin-bottom: 0px;
}
.advance-filter .multiselect__select {
  height: 34px;
}
.advance-filter .multiselect__tags {
  max-height: 35px;
  overflow: auto;
  min-height: unset;
  padding: 5px 40px 5px 5px;
}
.advance-filter .multiselect__content-wrapper {
  width: 100%;
}
.advance-filter .vs__dropdown-toggle {
  height: 35px;
}
</style>

<style scoped>
.loader-container {
  position: absolute;
  inset: 0;
  background: #ffffff99;
  z-index: 2;
  display: grid;
  place-content: center;
}
.loader-container .loader .lds-grid {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.loader-container .loader .lds-grid div {
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #000;
  animation: lds-grid 1.2s linear infinite;
}
.loader-container .loader .lds-grid div:nth-child(1) {
  top: 8px;
  left: 8px;
  animation-delay: 0s;
}
.loader-container .loader .lds-grid div:nth-child(2) {
  top: 8px;
  left: 32px;
  animation-delay: -0.4s;
}
.loader-container .loader .lds-grid div:nth-child(3) {
  top: 8px;
  left: 56px;
  animation-delay: -0.8s;
}
.loader-container .loader .lds-grid div:nth-child(4) {
  top: 32px;
  left: 8px;
  animation-delay: -0.4s;
}
.loader-container .loader .lds-grid div:nth-child(5) {
  top: 32px;
  left: 32px;
  animation-delay: -0.8s;
}
.loader-container .loader .lds-grid div:nth-child(6) {
  top: 32px;
  left: 56px;
  animation-delay: -1.2s;
}
.loader-container .loader .lds-grid div:nth-child(7) {
  top: 56px;
  left: 8px;
  animation-delay: -0.8s;
}
.loader-container .loader .lds-grid div:nth-child(8) {
  top: 56px;
  left: 32px;
  animation-delay: -1.2s;
}
.loader-container .loader .lds-grid div:nth-child(9) {
  top: 56px;
  left: 56px;
  animation-delay: -1.6s;
}
@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.line {
  width: 100%;
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}

.custom-width-btn {
  width: 40%;
}
.custom-heigth-btn {
  width: 100%;
}
.custom-font-size {
  font-size: 1rem;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
  .pointer {
    cursor: pointer;
  }
}
</style>
<style>
.modal-content-info .modal-dialo {
  max-width: 700px;
}
</style>
<style lang="scss">
.c-dropdown {
  .btn {
    height: 35.81px;
  }
  .dropdown-menu {
    z-index: 1000;
  }
}
</style>
<style>
.bitacora .multiselect__spinner {
  height: 30px;
}
.bitacora .multiselect__placeholder {
  margin-bottom: 0px;
}
.bitacora .multiselect__select {
  height: 34px;
}
.bitacora .multiselect__tags {
  max-height: 35px;
  overflow: auto;
  min-height: unset;
  padding: 5px 40px 5px 5px;
}
.indicator {
  display: grid;
  place-content: center;
}
.indicator > .info {
  background-color: #172b4d;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 120px;
  color: #fff;
  border-radius: 20px;
}
</style>
<style scoped>
>>> .td-overflow {
  overflow: hidden;
}
>>> .ceil-error {
  box-shadow: 0px 0px 0px 1000px #f5b4b5;
}
>>> .ubi-error {
  background: #ffe2e2;
  border: 1px solid #ff8181;
  color: #ff8181;
}
>>> [name="RightFixedTableHeader"] .table thead th {
  vertical-align: bottom;
  border-bottom: none;
}
>>> [name="TableBodyWrapper"] {
  margin-top: 0 !important;
}
</style>
